// extracted by mini-css-extract-plugin
export default {"Parent":"ProfileRequestHeader_Parent__fY+8N","Title":"ProfileRequestHeader_Title__7yV0U","Action":"ProfileRequestHeader_Action__6p7gn"};